module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-15.2b10f663.png";